module.exports = __webpack_public_path__ + "img/quest_icon_0069_monster.f7648db3.png";